import { useCallback } from 'react';
import useAxios from '../axios/useAxios';

export const useOrderLogger = () => {
  const axiosInstance = useAxios();

  const logPaymentMethodSlider = useCallback(
    (orderId, sliderOpen, userId) => {
      try {
        axiosInstance.post(
          `/orders/${orderId}/payment/method/slider`,
          {
            orderId,
            userId,
            sliderOpen,
          },
        );

        
      } catch (error) {
        console.error(error);
      }
    },
    [axiosInstance],
  );

  const logPaymentInitiated = useCallback((orderId, userId, paymentMethod, paymentGateway) => {
    try {
      axiosInstance.post(`/orders/${orderId}/payment/initiated`, {
        userId,
        paymentMethod,
        paymentGateway,
      });
    } catch (error) {
      console.error(error);
    }
  }, [axiosInstance]);

  const logEdenredLogin = useCallback(
    (orderId, userId, paymentMethod, success, edenredInfo = null) => {
      try {
        axiosInstance.post(
          `/orders/${orderId}/edenred/login`,
          {
            userId,
            paymentMethod,
            success,
            edenredInfo,
          },
        );


      } catch (error) {
        console.error(error);
      }
    },
    [axiosInstance],
  );

  const logPaymentWith3DSResult = useCallback((orderId, userId, isSuccessful, paymentInfos) => {
    try {
      axiosInstance.post(`/orders/${orderId}/payment/3DS`, {
        userId,
        isSuccessful,
        paymentInfos,
      });
    } catch(error) {
      console.error(error);
    }
  }, [axiosInstance]);

  const logPaymentMethodChanged = useCallback((orderId, userId, paymentMethod) => {
    try {
      axiosInstance.post(`/orders/${orderId}/payment/method/changed`, {
        userId,
        paymentMethod,
      });


    } catch (error) {
      console.error(error);
    }
  }, [axiosInstance]);

  const logPaymentFailedWithCard = useCallback((orderId, userId, paymentInfos) => {
    try {
      axiosInstance.post(`/orders/${orderId}/payment/failed`, {
        userId,
        paymentInfos,
      });
    } catch (error) {
      console.error(error);
    }
  }, [axiosInstance]);

  const logPaymentCancel = useCallback((orderId, userId, paymentInfos) => {
    try {
      axiosInstance.post(`/orders/${orderId}/payment/cancel`, {
        userId,
        paymentInfos,
      });
    } catch (error) {
      console.error(error);
    }
  }, [axiosInstance]);

  const logInvalidCheckoutQR = useCallback((orderId, userId, scannedCode, expectedStoreId) => {
    try {
      axiosInstance.post(`/orders/${orderId}/verification/invalid-qr`, {
        userId,
        scannedCode,
        expectedStoreId,
      });
    } catch (error) {
      console.error(error);
    }
  }, [axiosInstance]);

  const logScannerSlowLoading = useCallback((orderId, userId, {
    loadingDuration,
    thresholdMs = 10000,
    scannerType,
    deviceType,
    storeId,
    sessionId,
    platform,
  }) => {
    try {
      axiosInstance.post(`/orders/${orderId}/scanner/slow-loading`, {
        userId,
        loadingDuration,
        thresholdMs,
        scannerType,
        deviceType,
        storeId,
        sessionId,
        platform,
      });
    } catch (error) {
      console.error(error);
    }
  }, [axiosInstance]);

  return {
    logPaymentMethodSlider,
    logPaymentInitiated,
    logPaymentMethodChanged,
    logEdenredLogin,
    logPaymentWith3DSResult,
    logPaymentFailedWithCard,
    logPaymentCancel,
    logInvalidCheckoutQR,
    logScannerSlowLoading,
  };
};
